module.exports = __webpack_public_path__ + "assets/cbi-defaultaf5865c433c4af27a8e78dd7c6515506.svg";